var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('purchases-delivery-form',{attrs:{"loading":_vm.loading,"purchasesDeliveryData":_vm.purchasesDelivery,"formErrors":_vm.formErrors},on:{"purchasesDeliveriesubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }